/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { Icon } from "semantic-ui-react";
import * as THREE from "three";
import { FBXLoader } from "three/examples/jsm/loaders/FBXLoader";
import { loginCookieName } from "../App";
import { SettingsContext } from "../context";
import { getCookie } from "../Cookie";
import { GLTFExporterExt } from "../THREE_EXT/GLTFExporterExt";

var i = 0.0;
var up = true;

function DropGltfBackup() {
  const history = useHistory();
  const {
    setIsNewObj,
    gltfFile,
    lightingObj,
    getProductToUpdate,
    getProductMatches,
    environment,
    sceneActive,
    setSceneActive,
    logOut,
    setGlbOriginalFile,
  } = useContext( SettingsContext );

  const [productId, setProductId] = useState( "" );
  const [companyId, setCompanyId] = useState( "" );
  const [path, setPath] = useState( "" );
  const modelViewerRef = useRef();
  var scene = useState();
  var [modelViewer] = useState();

  useEffect( async () => {
    if ( !getCookie( loginCookieName ) ) {
      let path = window.location.pathname.replace( "/", "" );
      history.push( {
        pathname: "/login",
        state: { productUrl: path },
      } );
    }

    modelViewer = document.getElementById( "modelViewer" );
    let newPath = window.location.pathname.replace( "/", "" );

    if ( newPath && newPath != "" && newPath != path ) {
      let data = await getProductToUpdate( newPath );
      let matches = await getProductMatches( newPath );
      if ( !data ) return;

      if ( data.entegrationId ) {
        setSceneActive( false );
        setProductId( data.entegrationId );
        setCompanyId( data.company.id );
        setIsNewObj( false );
      } else {
        updateGltfSrc( data.gltfFileUrl );
      }

      setTimeout( () => {
        onModalUpdate();
      }, 1 );

      setPath( newPath );
    }
  }, [window.location.pathname] );

  const init = () => {
    modelViewer = document.getElementById( "modelViewer" );
    scene = modelViewer?.scene();
  };

  const createTag = () => {
    let model = document.getElementsByClassName( "model" )[0];
    model.innerHTML = `
    <sugar-model-viewer 
      id='modelViewer'
      ar
      material-search="true"
      interaction-prompt="none"
      editor="true"
      show-joint
      template="advanced"
      showDimension="true"
      shadow-intensity =  ${lightingObj[1].value}
      product-id='' company_id=${companyId}
      scrollable="pan-y"
      environment-image= '${environment == null
        ? ""
        : environment.text != null
          ? environment.text
          : ""
      }'
      exposure=${lightingObj[0].value}
      ar-scale='fixed'
      camera-controls
      show-model-group
      style="height:100vh;"
      quick-look-browsers='safari chrome'/>`;
  };

  const updateGltfSrc = ( data ) => {
    setSceneActive( false );
    modelViewer = document.getElementById( "modelViewer" );
    THREE.Cache.clear();
    modelViewer.src = data;
    //modelViewer.renderer().render();
  };

  const handleDrop = ( e ) => {
    THREE.Cache.clear();
    modelViewer = document.getElementById( "modelViewer" );
    document.dispatchEvent( new CustomEvent( "glb-dropped" ) );
    scene = modelViewer.scene();
    const file = e.dataTransfer.files[0];
    setGlbOriginalFile( file );
    init();
    createTag();
    loadModel( file );
    setIsNewObj( true );
    e.preventDefault();
    e.stopPropagation();
  };

  const loadModel = ( file ) => {
    if ( !file || !file.name ) return;

    let fileType = file.name.split( "." ).pop();
    if ( fileType == "glb" || fileType == "gltf" ) {
      loadGltf( file );
    } else {
      loadObj( file );
    }
  };

  const loadObj = ( file ) => {
    var fbxLoader = new FBXLoader();
    const fileReader = new FileReader();
    modelViewer = document.getElementById( "modelViewer" );
    scene = modelViewer.scene();

    const onload = ( event ) => {
      const data = event.currentTarget.result;
      fbxLoader.load( data, async ( object ) => {
        const exporter = new GLTFExporterExt();
        const glb = await exporter.parse( object, true );
        const blob = new Blob( [glb], { type: "application/glb" } );
        loadGltf( blob );
      } );
    };

    fileReader.onload = onload;
    fileReader.onerror = ( error ) => { };
    fileReader.readAsDataURL( file );
  };

  const loadGltf = ( file ) => {
    const fileReader = new FileReader();
    modelViewer = document.getElementById( "modelViewer" );
    scene = modelViewer.scene();
    const onload = ( event ) => {
      const data = event.currentTarget.result;
      const customGlbBlob = new Blob( [data], { type: "glb" } );
      const customGlbLink = window.URL.createObjectURL( customGlbBlob );
      modelViewer = document.getElementById( "modelViewer" );
      modelViewer.src = customGlbLink;
      modelViewer.style.display = "block";
      onModalUpdate();
    };

    fileReader.onload = onload;
    fileReader.onerror = onerror;
    fileReader.readAsArrayBuffer( file );
  };

  const onModalUpdate = () => {
    modelViewer.style.height = "100vh";
    setTimeout( () => {
      document.dispatchEvent( new CustomEvent( "glb-loaded" ) );
    }, 4000 );
  };

  const handleDragEnter = ( e ) => {
    setSceneActive( false );
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragLeave = ( e ) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragOver = ( e ) => {
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <>
      <Icon
        className="power off"
        onClick={() => {
          logOut();
          history.push( "/login" );
        }}
      />

      <div
        style={{ flexGrow: "1" }}
        id="modelZone"
        className={"drag-drop-zone"}
        onDrop={( e ) => handleDrop( e )}
        onDragOver={( e ) => handleDragOver( e )}
        onDragEnter={( e ) => handleDragEnter( e )}
        onDragLeave={( e ) => handleDragLeave( e )}
      >
        <div className="welcomeText">
          <strong>Welcome To The Sugar World </strong>
        </div>

        {sceneActive ? (
          <div>
            <div>
              <span>Drag GLB/FBX Here! </span>
            </div>{" "}
          </div>
        ) : null}
        <div />
        <div className="model" style={{ height: "100vh" }}>
          <sugar-model-viewer
            ref={modelViewerRef}
            id="modelViewer"
            ar
            material-search="true"
            interaction-prompt="none"
            shadow-intensity={lightingObj[1].value}
            product-id={productId}
            company_id={companyId}
            scrollable="pan-y"
            editor="true"
            template="advanced"
            joint-show=""
            showDimension="true"
            show-model-group
            camera-down-lock="false"
            camera-controls
            style={{ height: "100vh" }}
            environment-image={environment.text == null ? "" : environment.text}
            exposure={lightingObj[0].value}
            highlight-enabled="true"
            highlight-color="FF0000"
            highlight-by="material"
            quick-look-browsers="safari chrome"
          />
        </div>
      </div>
    </>
  );
}
export default DropGltfBackup;
